import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
// import './registerServiceWorker';

import Amplify, * as AmplifyModules from 'aws-amplify';
import { AmplifyPlugin } from 'aws-amplify-vue';
import aws_exports from '@/aws-exports';

import { Multiselect } from 'vue-multiselect';
import Toasted from 'vue-toasted';
import VueScrollTo from 'vue-scrollto';
import { ToggleButton } from 'vue-js-toggle-button';
import VueBreadcrumbs from 'vue-2-breadcrumbs';

import * as utilities from './utilities';

Vue.config.productionTip = false;

Amplify.configure(aws_exports);
Vue.use(AmplifyPlugin, AmplifyModules);

Vue.component('multiselect', {
  extends: Multiselect,
  props: {
    allowEmpty: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'name',
    },
    placeholder: {
      type: String,
      default: 'Search',
    },
    showLabels: {
      type: Boolean,
      default: false,
    },
    trackBy: {
      type: String,
      default: 'id',
    },
  }
});

Vue.component('multiselect-text', {
  extends: Multiselect,
  props: {
    allowEmpty: {
      type: Boolean,
      default: false,
    },
    clearOnSelect: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Search',
    },
    showLabels: {
      type: Boolean,
      default: false,
    },
    tagPlaceholder: {
      type: String,
      default: '<enter> to add',
    },
  }
});

Vue.component('multiselect-multiple', {
  extends: Multiselect,
  props: {
    clearOnSelect: {
      type: Boolean,
      default: false,
    },
    closeOnSelect: {
      type: Boolean,
      default: false,
    },
    hideSelected: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: 'name',
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: 'Search',
    },
    preserveSearch: {
      type: Boolean,
      default: true,
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    selectLabel: {
      type: String,
      default: '<enter> to select',
    },
    showNoResults: {
      type: Boolean,
      default: false,
    },
    tagPlaceholder: {
      type: String,
      default: '<enter> to add new',
    },
    trackBy: {
      type: String,
      default: 'id',
    },
  }
});

Vue.component('singleselect-number', {
  extends: Multiselect,
  props: {
    clearOnSelect: {
      type: Boolean,
      default: false,
    },
    allowEmpty: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Select',
    },
    showLabels: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  }
});

Vue.component('singleselect-text', {
  extends: Multiselect,
  props: {
    clearOnSelect: {
      type: Boolean,
      default: false,
    },
    allowEmpty: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Select',
    },
    showLabels: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  }
});

Vue.component('ToggleButton', ToggleButton)

Vue.use(Toasted, {
  theme: "bubble",
  position: 'bottom-right',
  duration: 6500,
} as any);

Vue.config.errorHandler = function (err: any, vm: any, info: any) {
  console.log(err);
  Vue.toasted.error(err.message || JSON.stringify(err));
}

Vue.use(VueScrollTo, {
  duration: 250,
  offset: -65,
});

Vue.use(VueBreadcrumbs);

Vue.prototype.$onecentral = utilities;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

// Log all Vuex mutations during development
if (process.env.NODE_ENV === 'development') {
  store.subscribe((mutation: any, state: any) => {
    console.log('☢', mutation.type, mutation.payload);
  });
}
